import React from 'react';
import PropTypes from 'prop-types';
import { ALPHANUMERIC_REGEX } from '../utils/constants';
import { PatternInput } from './PatternInput';

export const AlphanumericInput = React.forwardRef(({ onChange, value, ...props }, ref) => {
  return (
    <PatternInput
      {...props}
      ref={ref}
      value={value}
      onChange={onChange}
      pattern={ALPHANUMERIC_REGEX}
      inputMode='text'
    />
  );
});

AlphanumericInput.displayName = 'AlphanumericInput';

AlphanumericInput.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
};
